
import {Component, Vue} from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import {RequestPaging} from "@/utils/util";
import {apiImportPromotionModule1, apiPromotionModuleDel, apiPromotionModuleLists,} from '@/api/shop'
import {apiShopLists} from "@/api/IndustryRequests";

@Component({
  components: {
    lsPagination
  }
})
export default class PromotionModuleList extends Vue {
  pager: RequestPaging = new RequestPaging();
  shopData: any[] = []
  searchObj = {};
  importDialogVisible = false;
  importFile: any = null;
  importForm = {
    sid: '',
    fileName: '' // 新增文件名存储字段
  };

  async getLists(): Promise<void> {
    this.pager.request({
      callback: apiPromotionModuleLists,
      params: this.searchObj
    });
  }

  async onDelete(row: any): Promise<void> {
    await apiPromotionModuleDel({id: row.id});
    this.getLists();
  }

  // 处理导入文件
  handleImportFile(file: any) {
    this.importFile = file;
    this.importForm.fileName = file.name; // 保存文件名
  }

  // 执行导入
  async handleImport() {
    if (!this.importFile) {
      this.$message.warning('请选择要导入的文件');
      return;
    }

    if (!this.importForm.sid) {
      this.$message.warning('请选择商城');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('file', this.importFile.raw);
      formData.append('sid', this.importForm.sid);

      // 这里需要添加实际的导入API
      await apiImportPromotionModule1(formData);

      // this.$message.success('导入成功');
      this.importDialogVisible = false;
      await this.getLists();
    } catch (error) {
      // this.$message.error('导入失败');
      console.error(error);
    }
  }

  reset(): void {
    Object.keys(this.searchObj).map((key) => {
      this.$set(this.searchObj, key, "");
    });
    this.getLists();
  }

  async getShopListsFn(): Promise<void> {
    const res: any = await apiShopLists({
      page_no: 1,
      page_size: 100,
    })
    this.shopData = res.lists;
  }

  created() {
    this.getLists();
    // 获取商城列表是数据
    this.getShopListsFn()
  }
}
